var React = require('react');

function IconEyeShow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M2,12.0023142 C3.61639415,15.6207873 7.58327864,18 12,18 C16.4167214,18 20.3836058,15.6207873 22,12.0023142 C20.3832075,8.3834836 16.4172437,6.00298752 12,6 C7.58275633,6.00298752 3.6167925,8.3834836 2,12.0023142 Z M8,12.0015428 C8,9.79155173 9.79086101,8 12,8 C14.209139,8 16,9.79155173 16,12.0015428 C16,14.2115338 14.209139,16.0030856 12,16.0030856 C9.79086101,16.0030856 8,14.2115338 8,12.0015428 Z M10,12.0007714 C10,10.8957759 10.8954305,10 12,10 C13.1045695,10 14,10.8957759 14,12.0007714 C14,13.1057669 13.1045695,14.0015428 12,14.0015428 C10.8954305,14.0015428 10,13.1057669 10,12.0007714 Z"}));
}

IconEyeShow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconEyeShow;

IconEyeShow.default = IconEyeShow;
